import { useState } from 'react';
import { useStore } from 'store/store';
import { useUtxEarnSubscriptionsAutoRenewal } from '@utx/utx-client';

export interface UseAutoRenewal {
  mutate: ReturnType<typeof useUtxEarnSubscriptionsAutoRenewal>;
  isSuccess: boolean;
  isAcknowledged: boolean;
  handleConfirm: () => void;
  toggleAcknowledge: () => void;
}

interface UseAutoRenewalParams {
  subscriptionId: string;
  autoRenewal: boolean;
  onClose?: () => void;
  onRefresh?: () => void;
}

export const useAutoRenewal = (props: UseAutoRenewalParams): UseAutoRenewal => {
  const store = useStore();

  const { subscriptionId, autoRenewal, onClose, onRefresh } = props;
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const mutate = useUtxEarnSubscriptionsAutoRenewal({
    mutation: {
      onSuccess: () => {
        console.log('@success');
        onRefresh && onRefresh();
        setIsSuccess(true);
      }
    },
    axios: {
      headers: {
        Authorization: `Bearer ${store.authToken}`
      },
      params: {
        subscriptionId,
        autoRenewal
      }
    }
  });

  async function handleConfirm() {
    if (!isAcknowledged) return;
    mutate.mutate({
      data: {
        subscriptionId,
        autoRenewal
      }
    });
  }

  function toggleAcknowledge() {
    setIsAcknowledged((prev) => !prev);
  }

  return {
    mutate,
    isSuccess,
    isAcknowledged,
    handleConfirm,
    toggleAcknowledge
  };
};
